import { Link } from "react-router-dom";
import styles from "./style/Startpage.module.css";
import Music from "./image15.png";

function ChangeContent() {
  let first = document.getElementById("First");
  let show = document.getElementById("Show");
  first.style.display = "none";
  show.style.display = "grid";
}

function Startpage() {
  return (
    <div className={styles.main}>
      <div className={styles.first} id="First">
        Rhythm <br />
        with Game
        <div className={styles.start} onClick={ChangeContent}>
          Start the journey
        </div>
      </div>
      <div className={styles.show} id="Show">
        <div className={styles.title}>Rhythm with Game</div>
        <div className={styles.text}>A playable website for music</div>
        <div className={styles.link}> </div>
        <Link to="/introduction" className={styles.link}>
          <div> Introduction</div>
        </Link>
        <Link to="/games" className={styles.link}>
          <div>Games</div>
        </Link>
        <Link to="/story" className={styles.link}>
          <div>Creator’s Story</div>
        </Link>
        <Link to="/music" className={styles.link}>
          <div>
            <img className={styles.listen} src={Music} /> Enjoy the Music
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Startpage;
